export const Projects = () => {
  return (
    <>
      <section id="projects">
        <div className="wrapper">
          <div className="pros">
            <div className="proImg">
              <img
                src="https://ik.imagekit.io/ubdvpx7xd0j/Femi_Obadimu/edike_mQoD9tIDu.png?updatedAt=1680914876978"
                alt="Edike.ng logo"
              />
            </div>

            <div className="proText">
              <h1 className="h1BG">Edike</h1>

              <p>
                 Our goal at Edike is to improve access to education in Nigeria and Africa by bridging the funding gap that exists on the consumer side. We are building a user-friendly ecosystem that provides resources which aids learning and supports parents with the management of financial obligation of their lads school fees.
              </p>

              <a
                href="https://edike.ng/"
                target="_blanket"
                rel="noopener"
                className="_aCapture"
              >
                see site
                <span></span>
              </a>
            </div>
          </div>
          <div className="pros">
            <div className="proImg">
              <img
                src="https://ik.imagekit.io/ubdvpx7xd0j/Femi_Obadimu/1656141449657_0Qc5uzGSw.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1666485108788"
                alt="Firansefood logo"
              />
            </div>

            <div className="proText">
              <h1 className="h1BG">Firansefood</h1>

              <p>
                At FiranṣẹFood, we are committed to spreading love and
                happiness. Gift food to your loved ones and have access to your
                favourite meal, dishes, cravings, snacks or dessert all the
                time. These are ways we can spread love and put a smile on your
                face or that of your loved ones. With us, you will be able to
                create a closer bond with them all with their favourite food.
                Install our #1 mobile app today!
              </p>

              <a
                href="https://dashboard.firansefood.com/auth/login"
                target="_blanket"
                rel="noopener"
                className="_aCapture"
              >
                see site
                <span></span>
              </a>
            </div>
          </div>
          <div className="pros">
            <div className="proImg">
              <img
                src="https://ik.imagekit.io/ubdvpx7xd0j/Femi_Obadimu/ogamoniwhite_bs-qbr_RK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1664229025998"
                alt="ogamoni"
              />
            </div>

            <div className="proText">
              <h1 className="h1BG">Ogamoni HQ</h1>

              <p>
                Oversee all your personal finance in one place, Start managing
                your finance in a smart way, We are dedicated to making personal
                finance seamless for Africans and the world.
              </p>

              <a
                href="https://ogamoni.com/"
                target="_blanket"
                rel="noopener"
                className="_aCapture"
              >
                see site
                <span></span>
              </a>
            </div>
          </div>
          <div className="pros">
            <div className="proImg works-bg">
              <img
                src="https://ik.imagekit.io/ubdvpx7xd0j/Femi_Obadimu/bigbread_ygNADjJ2M.png?ik-sdk-version=javascript-1.4.3&updatedAt=1649437125469"
                alt="Mart Bread's logo"
                className="works-bg"
              />
            </div>

            <div className="proText">
              <h1 className="h1BG">Mart Bread.</h1>
              <p>
                E-commerce Web Application .<br />a realtime application,
                accurately optimised to give users the ability to perform
                carting functions / buying products via the application
              </p>
              {/* <p>ubdvpx7xd0j</p> */}
              {/* https://ik.imagekit.io/ubdvpx7xd0j/Femi_Obadimu/ficazzo_sHKulH8GM.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1649436954428 */}
              <a
                href="https://mart-bread.herokuapp.com/"
                target="_blanket"
                rel="noopener"
                className="_aCapture"
              >
                see Mart Bread.
                <span></span>
              </a>
            </div>
          </div>

          <div className="pros">
            <div className="proImg">
              <img
                src="https://ik.imagekit.io/ubdvpx7xd0j/Femi_Obadimu/shecreatesfirelogo_QBa0Q49VI.png?ik-sdk-version=javascript-1.4.3&updatedAt=1654589880529"
                alt="She Creates Fire logo"
              />
            </div>

            <div className="proText">
              <h1 className="h1BG">She Creates Fire</h1>

              <p>
                She creates fire is a full scale blog application, with many
                realtime functionalities and integrations. It was built to fit
                users giving them a friendly feel and great experience{" "}
              </p>

              <a
                href="https://shecreatesfire.herokuapp.com/"
                target="_blanket"
                rel="noopener"
                className="_aCapture"
              >
                see site
                <span></span>
              </a>
            </div>
          </div>

          {/* <div className="pros">
                        <div className="proImg">
                            <img src="https://www.tryklas.com/img/logo-k.da0a2b07.svg" style={{ height: "80px" }} alt="klas's logo"/>
                        </div>

                        <div className="proText">
                            <h1 className="h1BG">
                                Klas
                            </h1>

                            <p>
                                Teach anything, anywhere<br/>
                                Klas is the easiest way to schedule, monetize, and host live classes. All from your browser.
                            </p>

                            <a href="https://tryklas.com" target="_blanket" rel="noopener"  className="_aCapture">
                                see klas
                                <span></span>
                            </a>
                        </div>
                    </div> */}

          {/* <div className="pros">
                        <div className="proImg">
                            <img src="https://ik.imagekit.io/9ghb9cknpe/favicon_7s2Zj0XGnnu.png?ik-sdk-version=javascript-1.4.3&updatedAt=1644323602570" alt="churchRUSH's logo"/>
                        </div>

                        <div className="proText">
                            <h1 className="h1BG">
                                ChurchRUSH
                            </h1>

                            <p>
                                A safe place to grow in faith, have an encounter with God, find your community and fufill your purpose. 
                            </p>

                            <a href="https://churchrush.com" target="_blanket" rel="noopener" className="_aCapture">
                                see site.
                                <span></span>
                            </a>
                        </div>
                    </div> */}
          {/* 
                    <div className="pros">
                        <div className="proImg">
                        <img src="https://enyata.vercel.app/enyata-white.svg" alt="Enyata's logo" style={{height: "40px"}}
                        />
                        </div>

                        <div className="proText">
                            <h1 className="h1BG">
                                Enyata Clone
                            </h1>

                            <p>
                                A Clone of enyata.com official website, built in nextjs and scss.
                            </p>

                            <a href="https://enyata.vercel.app" target="_blanket" rel="noopener" className="_aCapture">
                                see site.
                                <span></span>
                            </a>
                        </div>
                    </div> */}
        </div>
      </section>
    </>
  );
};
